import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCitiesAction } from "redux/actions/RegiteringListsActions/getCitiesAction";
import { getCountriesAction } from "redux/actions/RegiteringListsActions/getCountriesAction";
import { RootState } from "redux/rootReducer";
import { getTitlesAction } from "redux/actions/RegiteringListsActions/getTitlesAction";

const useDropdown = () => {
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(getCountriesAction());
    dispatch(getCitiesAction(1));
    dispatch(getTitlesAction());
  }, []);

  const { countries, getCountriesLoading } = useSelector(
    (state: RootState) => state.getCountriesReducer
  );

  const { cities, citiesLoading } = useSelector(
    (state: RootState) => state.getCitiesReducer
  );

  const { titles, titlesLoading } = useSelector(
    (state: RootState) => state.getTitlesReducer
  );

  //   countries dropdown **************************************
  const countriesDropdownEnglish = countries?.items?.map(
    (item: any, i: number) => {
      return {
        label: item?.value_en,
        value: item?.id,
      };
    }
  );

  const countriesDropdownArabic = countries?.items?.map(
    (item: any, i: number) => {
      return {
        label: item?.value_ar,
        value: item?.id,
      };
    }
  );

  //   cities dropdown **************************************
  const citiesDropdownEnglish = cities?.items?.map((item: any, i: number) => {
    return {
      label: item?.value_en,
      value: item?.id,
    };
  });

  const citiesDropdownArabic = cities?.items?.map((item: any, i: number) => {
    return {
      label: item?.value_ar,
      value: item?.id,
    };
  });

  //   titles dropdown **************************************
  const titlesDropdownEnglish = titles?.items?.map((item: any, i: number) => {
    return {
      label: item?.value_en,
      value: item?.id,
    };
  });

  const titlesDropdownArabic = titles?.items?.map((item: any, i: number) => {
    return {
      label: item?.value_ar,
      value: item?.id,
    };
  });

  return {
    countriesDropdownEnglish,
    countriesDropdownArabic,
    getCountriesLoading,
    citiesDropdownEnglish,
    citiesDropdownArabic,
    citiesLoading,
    titlesDropdownEnglish,
    titlesDropdownArabic,
    titlesLoading,
  };
};

export { useDropdown };
